(function () {
  'use strict';
  function connect(page) {
    if (page.dataset.mergedConnected) return;
    page.dataset.mergedConnected = 'true';
    function update() {
      var input = page.querySelector('[data-variant-id]');
      if (!input) return;
      var template = page.querySelector('template[data-merged-variant="' + input.value + '"]');
      if (!template) return;
      var option = page.querySelector('[data-option-select]');
      page.querySelectorAll('[data-option-tile]').forEach(function (tile) {
        if (option && tile.dataset.optionValue === option.value) tile.setAttribute('aria-current', 'true');
        else tile.removeAttribute('aria-current');
      });
      var selected = page.querySelector('[data-merged-option-value]');
      if (selected && option) selected.textContent = option.value;
      ['information', 'faq', 'key-facts'].forEach(function (name) {
        var target = page.querySelector('[data-merged-' + name + ']');
        var source = template.content.querySelector('[data-merged-' + name + '-source]');
        if (target && source) target.replaceChildren(source.cloneNode(true));
      });
      var sku = page.querySelector('[data-merged-sku]');
      if (sku) sku.textContent = template.dataset.sku;
      if (page.hasAttribute('data-variant-paths') && template.dataset.metaTitle) {
        document.title = template.dataset.metaTitle;
        var canonical = document.querySelector('link[rel="canonical"]');
        if (canonical) canonical.href = template.dataset.canonical;
        var heading = page.querySelector('[data-merged-heading]');
        if (heading) heading.textContent = template.dataset.heading;
        [
          ['meta[name="description"]', template.dataset.metaDescription],
          ['meta[property="og:title"]', template.dataset.metaTitle],
          ['meta[property="og:description"]', template.dataset.metaDescription],
          ['meta[property="og:url"]', template.dataset.canonical],
          ['meta[name="twitter:title"]', template.dataset.metaTitle],
          ['meta[name="twitter:description"]', template.dataset.metaDescription],
          ['meta[property="product:price:amount"]', template.dataset.priceAmount],
          ['meta[property="product:availability"]', template.dataset.availability]
        ].forEach(function (entry) { var meta = document.querySelector(entry[0]); if (meta) meta.content = entry[1]; });
        var image = page.querySelector('[data-main-image]');
        if (image) ['meta[property="og:image"]', 'meta[property="og:image:secure_url"]', 'meta[name="twitter:image"]'].forEach(function (selector) { var meta = document.querySelector(selector); if (meta) meta.content = image.src; });
      }
    }
    page.querySelectorAll('[data-option-select]').forEach(function (select) {
      // The existing theme updates the selected variant ID in its change handler.
      select.addEventListener('change', function () { queueMicrotask(update); });
    });
    page.querySelectorAll('[data-option-tile]').forEach(function (tile) {
      tile.addEventListener('click', function (event) {
        // Keep real variant links for no-script navigation and opening a new tab.
        if (event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        var option = page.querySelector('[data-option-select][data-option-index="' + tile.dataset.optionIndex + '"]');
        if (!option) return;
        event.preventDefault();
        option.value = tile.dataset.optionValue;
        option.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
    window.addEventListener('popstate', function () { window.location.reload(); });
  }
  function init(root) { root.querySelectorAll('[data-merged-product]').forEach(connect); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
